import agent from '../../../api/agent';
import { Menu } from 'semantic-ui-react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';

function SmartFlowListForRestoration() {  
  const navigate = useNavigate();

  const clickHandler = async () => {
    const response = await agent.AssetTypes.smartflowTemplate();
    const selectedItem = response.data?.find((e:any) => e.name === 'Reel_Cutlist_Cutlist Workflow');
    const ids = selectedItem ? selectedItem.id.split('_') : [];
      if (ids.length === 3) {
        const routeId = `/smart_flow/asset/${ids[0]}/element/${ids[1]}/template/${ids[2]}`;
        navigate(routeId);
      }
  };

  return (
    <Menu.Item onClick={clickHandler} style={{ paddingLeft: 0, paddingRight: 0 }}>
      <span style={{ color: '#616161', cursor: 'pointer',marginLeft:'18px' }}>  SmartFlow</span>
    </Menu.Item>
  );
}

export default observer(SmartFlowListForRestoration);
